import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AllowanceEntity,
  BokkzAlgDataService,
  BokkzTslDataService,
  BokkzTslLogic,
  ClientEntity,
  GezinEninkomenPerMaand
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {filter, Subject, takeUntil} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {CommonModule} from '@angular/common';
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss'],
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    ReactiveFormsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    CommonModule,
    SharedUiAlertModule
  ]
})
export class PartnerComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private destroy$ = new Subject<void>();
  private clientEntity ={} as ClientEntity;
  private isSaving = false;
  public allowanceEntity = {} as AllowanceEntity;
  public inkomenFg = {} as FormGroup;
  public hasPartner = false;
  private focusedElementId: string | null = null;
  public formStructure: any;
  public year: any;
  public label1: any;
  public label2: any;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  constructor(
    public dataService: BokkzTslDataService,
    public dataAlgService: BokkzAlgDataService,
    private router: Router,
    public tslLogic: BokkzTslLogic,
    private fb: FormBuilder) {
    this.inkomenFg = this.fb.group({
      inkomensgegevens: this.fb.array<GezinEninkomenPerMaand>([])
    })
  }

  public getLabel(index: number): any {
    if (index === 1) {
      return "Januari";
    }
    if (index === 2) {
      return "Februari";
    }
    if (index === 3) {
      return "Maart";
    }
    if (index === 4) {
      return "April";
    }
    if (index === 5) {
      return "Mei";
    }
    if (index === 6) {
      return "Juni";
    }
    if (index === 7) {
      return "Juli";
    }
    if (index === 8) {
      return "Augustus";
    }
    if (index === 9) {
      return "September";
    }
    if (index === 10) {
      return "Oktober";
    }
    if (index === 11) {
      return "November";
    }
    if (index === 12) {
      return "December";
    }
  }

  get inkomensgegevens(): FormArray {
    return this.inkomenFg.get('inkomensgegevens') as FormArray;
  }

  createFormGroup(gez?: GezinEninkomenPerMaand): FormGroup {
    return this.fb.group<GezinEninkomenPerMaand>({
      maand: gez ? gez.maand : null as unknown as number,
      toeslagPartner: true,
      geboortedatumPartner: gez ? gez.geboortedatumPartner : null as unknown as Date,
      bsnPartner: gez ? gez.bsnPartner : null as unknown as string,
      toetsinkomenAangever: gez ? gez.toetsinkomenAangever : null as unknown as number,
      toetsinkomenPartner: gez ? gez.toetsinkomenPartner : null as unknown as number,
      toetsvermogenAangever: gez ? gez.toetsvermogenAangever : null as unknown as number,
      toetsvermogenPartner: gez ? gez.toetsvermogenPartner : null as unknown as number,
      aangeverHeeftZorgverzekering: gez ? gez.aangeverHeeftZorgverzekering : null as unknown as boolean,
      partnerHeeftZorgverzekering: gez ? gez.partnerHeeftZorgverzekering : true,
    });
  }

  public ngOnInit(): void {
    this.dataService.allowanceEntity.pipe(takeUntil(this.destroy$)).subscribe((allowanceEntity) => {
      this.allowanceEntity = allowanceEntity;
      this.year = allowanceEntity.year;
      this.label1 = "Inkomen geheel " + allowanceEntity.year
      this.label2 = "Vermogen geheel " + allowanceEntity.year
      this.updateForm();
    });
    this.dataAlgService.client.pipe(takeUntil(this.destroy$)).subscribe((clientEntity)=> {
      this.clientEntity=clientEntity;
    });
    this.dataService.hasPartner.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.hasPartner = value;
    })
    this.router.events.pipe(
      takeUntil(this.destroy$),
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {this.handleUrlChange()});
  }

  private updateForm(): void {
    const lijst = this.allowanceEntity?.toeslagen?.inkomensgegevens || [];
    const formArray = this.inkomenFg.get('inkomensgegevens') as FormArray;
    const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
    while (formArray.length > lijst.length) {
      formArray.removeAt(formArray.length - 1);
    }

    for (let i = 0; i < lijst.length; i++) {
      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(lijst[i]);
      } else {
        const formGroup = this.createFormGroup(lijst[i])
        formArray.push(formGroup);
      }
    }
    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  saveForm(): void {
    setTimeout(()=> {
      this.inkomenFg.updateValueAndValidity();
      this.allowanceEntity.toeslagen = {
        ...this.allowanceEntity.toeslagen,
        inkomensgegevens: this.inkomenFg.value.inkomensgegevens
      } as AllowanceEntity
      this.dataService.updateAllowanceTaxEntity(this.allowanceEntity);
    },50)
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleUrlChange() {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.tslLogic.postAllowances(this.clientEntity.sstRelationId!, this.allowanceEntity, false);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.inkomenFg.dirty
  }

  copyFromPrevious(index: number): void {
    if (index <= 0) return;

    const previousData = { ...this.inkomensgegevens.at(index - 1).value };
    previousData.maand = index + 1;

    this.inkomensgegevens.at(index).patchValue(previousData);
    this.saveForm();
  }




}
